import { pxArrayToRem, pxToRem } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { APPEAR_ANIMATION_DURATION } from '@modules/paint-picker-new/config';

export const ColourRow: StyleRule = () => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    cursor: 'pointer',
});

export const ColourPickRow: StyleRule = ({ theme }) => ({
    borderRight: '1px solid #e4e4e4',
    padding: pxArrayToRem([0, 12]),

    [theme.screen.laptop]: {
        borderRight: 'none',
        padding: 0,
    },
});

export const ColourDetails: StyleRule = ({ theme }) => ({
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    [theme.screen.laptop]: {
        padding: pxArrayToRem([0, 8]),
    },
});

export const ColourName: StyleRule = ({ theme }) => ({
    marginTop: pxToRem(7),
    marginBottom: pxToRem(12),
    width: pxToRem(80),
    height: '100%',
    fontSize: pxToRem(12),
    lineHeight: pxToRem(12),
    color: '#000',
    textAlign: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

    [theme.screen.laptop]: {
        width: 'unset',
        lineClamp: 'unset',
        whiteSpace: 'normal',
        marginBottom: 0,
    },
});

export const ColourPick: StyleRule = () => ({
    display: 'grid',
    alignItems: 'center',
    justifyItems: 'center',

    '> *': {
        gridArea: '1 / 1',
    },
});

export const AddToPaletteMobile: StyleRule = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: pxArrayToRem([6, 8]),
    borderRadius: pxToRem(12),
    backgroundColor: '#f8f6f4',
    fontSize: pxToRem(12),
    lineHeight: 1,
    color: '#000',
    whiteSpace: 'nowrap',
});

export const AddToPaletteMobileDisabled: StyleRule = () => ({
    opacity: 0.5,
});

export const ColourPickIcon: StyleRule = () => ({
    zIndex: 2,
});

export const ColourPickIconMobile: StyleRule = () => ({
    zIndex: 2,
    width: pxToRem(14),
    height: pxToRem(14),

    '& svg': {
        width: pxToRem(14),
        height: pxToRem(14),
    },
});

export const ColourPickCollapsedIcon: StyleRule = () => ({
    zIndex: 2,
    width: pxToRem(14),
    height: pxToRem(14),

    '& svg': {
        width: pxToRem(14),
        height: pxToRem(14),
    },
});

export const titleAnimation = {
    open: {
        height: '100%',
        marginTop: pxToRem(7),
        fontSize: pxToRem(12),
        lineHeight: pxToRem(12),
        transition: { duration: APPEAR_ANIMATION_DURATION / 2 },
    },
    closed: {
        height: 0,
        marginTop: 0,
        fontSize: 0,
        lineHeight: 0,
        transition: { duration: APPEAR_ANIMATION_DURATION / 2 },
    },
};

export const pickIconAnimation = {
    open: {
        opacity: 1,
        transition: { duration: APPEAR_ANIMATION_DURATION },
    },
    closed: {
        opacity: 0,
        transition: { duration: APPEAR_ANIMATION_DURATION },
    },
};

export const pickCollapsedIconAnimation = {
    open: {
        opacity: 0,
        transition: { duration: APPEAR_ANIMATION_DURATION },
    },
    closed: {
        opacity: 1,
        transition: { duration: APPEAR_ANIMATION_DURATION },
    },
};
